import { GameMap, TileType } from '../../simulation/types/GameMap';
import { SimNPC } from '../../simulation/types/SimNPC';

export interface RenderConfig {
  tileSize: number;
  npcSize: number;
  showGrid: boolean;
}

/**
 * タイル色マッピング
 */
function getTileColor(type: TileType): string {
  const colors: Record<TileType, string> = {
    grass: '#90EE90', // 薄緑
    forest: '#228B22', // 濃緑
    water: '#4682B4', // 青
    food_spot: '#FFD700', // 金
    town: '#8B4513', // 茶色
    mountain: '#808080', // 灰色
    // 属性ゾーン
    fire_zone: '#FF4500', // 炎 (オレンジ赤)
    water_zone: '#1E90FF', // 水 (ドジャーブルー)
    light_zone: '#FFD700', // 光 (ゴールド)
    dark_zone: '#4B0082', // 闇 (インディゴ)
    primitive_zone: '#8B4513', // 原始 (サドルブラウン)
    future_zone: '#00CED1', // 未来 (ダークターコイズ)
    // 特殊ゾーン
    forbidden_zone: '#800000', // 禁忌の地 (マルーン/暗赤色)
  };
  return colors[type];
}

/**
 * タイル描画
 */
export function renderTile(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  type: TileType,
  config: RenderConfig
): void {
  const { tileSize } = config;
  const px = x * tileSize;
  const py = y * tileSize;

  ctx.fillStyle = getTileColor(type);
  ctx.fillRect(px, py, tileSize, tileSize);

  // グリッド線
  if (config.showGrid) {
    ctx.strokeStyle = '#00000020';
    ctx.lineWidth = 1;
    ctx.strokeRect(px, py, tileSize, tileSize);
  }
}

/**
 * NPC描画
 */
export function renderNPC(
  ctx: CanvasRenderingContext2D,
  npc: SimNPC,
  config: RenderConfig
): void {
  const { tileSize, npcSize } = config;
  const px = npc.position.x * tileSize + (tileSize - npcSize) / 2;
  const py = npc.position.y * tileSize + (tileSize - npcSize) / 2;

  // NPC円
  ctx.fillStyle = npc.isAlive ? '#FF6347' : '#696969';
  ctx.beginPath();
  ctx.arc(px + npcSize / 2, py + npcSize / 2, npcSize / 2, 0, Math.PI * 2);
  ctx.fill();

  // 枠線
  ctx.strokeStyle = '#000';
  ctx.lineWidth = 2;
  ctx.stroke();

  // 名前（小）
  ctx.fillStyle = '#000';
  ctx.font = '10px sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText(npc.name, px + npcSize / 2, py - 4);
}

/**
 * マップ全体描画
 */
export function renderMap(
  ctx: CanvasRenderingContext2D,
  map: GameMap,
  npcs: SimNPC[],
  config: RenderConfig
): void {
  // 背景クリア
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

  // タイル描画
  for (let y = 0; y < map.height; y++) {
    for (let x = 0; x < map.width; x++) {
      renderTile(ctx, x, y, map.tiles[y][x].type, config);
    }
  }

  // NPC描画
  for (const npc of npcs.filter((n) => n.isAlive)) {
    renderNPC(ctx, npc, config);
  }
}
